export const GET_TRANSFER_HISTORY_REQUEST = "GET_TRANSFER_HISTORY_REQUEST";
export const GET_TRANSFER_HISTORY_SUCCESS = "GET_TRANSFER_HISTORY_SUCCESS";
export const GET_TRANSFER_HISTORY_ERROR = "GET_TRANSFER_HISTORY_ERROR";
export const REMOVE_TRANSFER_HISTORY = "REMOVE_TRANSFER_HISTORY";
//  all crypto 

export const GET_CRYPTO_HISTORY_REQUEST = "GET_CRYPTO_HISTORY_REQUEST";
export const GET_CRYPTO_HISTORY_SUCCESS = "GET_CRYPTO_HISTORY_SUCCESS";
export const GET_CRYPTO_HISTORY_ERROR = "GET_CRYPTO_HISTORY_ERROR";
export const REMOVE_CRYPTO_HISTORY = "REMOVE_CRYPTO_HISTORY";
